ft-button(
  danger,
  disabled=isDisabled,
  (click)=this.sendAll()
) Send all matches

